import { render, staticRenderFns } from "./productEdit.vue?vue&type=template&id=d42c9d8e&scoped=true&"
import script from "./productEdit.vue?vue&type=script&lang=js&"
export * from "./productEdit.vue?vue&type=script&lang=js&"
import style0 from "./productEdit.vue?vue&type=style&index=0&id=d42c9d8e&lang=scss&scoped=true&"
import style1 from "./productEdit.vue?vue&type=style&index=1&id=d42c9d8e&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42c9d8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/integrationtest/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d42c9d8e')) {
      api.createRecord('d42c9d8e', component.options)
    } else {
      api.reload('d42c9d8e', component.options)
    }
    module.hot.accept("./productEdit.vue?vue&type=template&id=d42c9d8e&scoped=true&", function () {
      api.rerender('d42c9d8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/productEdit.vue"
export default component.exports